import { zodTransformFirestoreTimestampToDate } from "../../utils/zodUtils.mjs";
import { zodFlavorId } from "../ids.mjs";
import { defineFirestoreCollection } from "../firebaseCollectionSchema.mjs";
import { PiiCategory, meta } from "../meta.mjs";
import { z as z$1 } from "zod";

// src/models/consultation/consultantLicensedStatesCache.ts
/** Singleton doc under `consultants_cache`. */
const CONSULTANT_LICENSED_STATES_CACHE_DOC_ID = "licensed_states";
const consultantLicensedStatesCacheSchema = z$1.object({
	id: zodFlavorId(),
	/** Tellescope userId → licensed US state codes for bookable clinical consultants. */
	userLicensedStateCodes: z$1.record(meta(z$1.string(), { pii: { category: "medicalId" } }), z$1.array(meta(z$1.string(), { pii: { category: "geo" } }))),
	/** Tellescope userId → consultantId for bookable clinical NPs. */
	userIdToConsultantId: z$1.record(meta(z$1.string(), { pii: { category: "medicalId" } }), meta(z$1.string(), { pii: { category: "identifier" } })),
	/** Tellescope userId → public display name for bookable clinical NPs (e.g. "Alex Rivera, NP"). */
	userIdToConsultantDisplayName: z$1.record(meta(z$1.string(), { pii: { category: "medicalId" } }), meta(z$1.string(), { pii: { category: "name" } })).optional().default({}),
	updatedAt: z$1.any().transform(zodTransformFirestoreTimestampToDate)
});
const ConsultantsCache = defineFirestoreCollection("consultants_cache", consultantLicensedStatesCacheSchema, void 0, { dwReplication: false });

export { CONSULTANT_LICENSED_STATES_CACHE_DOC_ID, ConsultantsCache, consultantLicensedStatesCacheSchema };
//# sourceMappingURL=consultantLicensedStatesCache.mjs.map